import { css } from '@emotion/react';
import { theme } from '../../theme/theme';

export const selectStyle = css`
  padding: ${theme.space.sm}px ${theme.space.md}px;
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.sm}px;
  background: ${theme.color.surface};
  color: ${theme.color.text};
  font-size: ${theme.fontSize.md}px;

  &:invalid,
  & option[value=''] {
    color: ${theme.color.textMuted};
  }
`;
